import { menuClasses } from "react-pro-sidebar";

export const menuStyles = {
  ["." + menuClasses.button]: {
    // backgroundColor: "white !important",
    // backgroundColor: "#061a40 !important",
    fontSize: "80%",
    color: "white !important",
    marginRight: "5px !important",
    marginLeft: "5px !important",
    // padding: "0px !important",
    // paddingLeft: "3px !important",
    marginBottom: "1vh",
    borderRadius: "10px",
    "&:hover": {
      borderRadius: "10px",
      // borderP
      // backgroundColor: "#58698a !important",
      backgroundColor: "var(--sidebar-active) !important",
      color: "black !important",
    },
  },
};

export const subMenuStyles = {
  ["." + menuClasses.button]: {
    // backgroundColor: "white !important",
    // backgroundColor: "#061a40 !important",
    fontSize: "80%",
    color: "white !important",
    marginRight: "5px !important",
    marginLeft: "5px !important",
    marginBottom: "1vh",
    borderRadius: "10px",
    "&:hover": {
      borderRadius: "10px",
      // borderP
      // backgroundColor: "#58698a !important",
      backgroundColor: "var(--sidebar-active) !important",
      color: "black !important",
    },
  },
};
